export default {
  IMG_TYPES: ['png', 'gif', 'jpeg', 'jpg', 'bmp'],
};
